module["exports"] = ["sk", "com", "net", "eu", "org"];